import React from 'react';
import styled from 'styled-components';
import { useAppDispatch } from '../../../redux/hooks';
import { ModalSliceType, openModal } from '../../../redux/slices/modal';
import { tileItemStyles } from './TilesUI';
import { SvgIcon } from '../../../components/Icon';
import { SecondaryButton } from '../../../components/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${tileItemStyles};
`;

const NewTile = () => {
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(openModal({ type: ModalSliceType.UpsertTile, data: null }));
  };

  return (
    <Container>
      <SecondaryButton size="default" onClick={handleClick} isOutlined={true}>
        <SvgIcon name="plus" width={24} height={24} customFill="currentColor" />
        Create a tile
      </SecondaryButton>
    </Container>
  );
};

export default NewTile;
